import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MapModule } from '@eview/features/ui/map/map.module';
import { SearchableSelectModule } from '@eview/features/ui/searchable-select/searchable-select.module';
import { UIModule } from '@eview/web';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormAttributeComponent } from './post-editor/form-attribute/form-attribute.component';
import { PostEditorPageComponent } from './post-editor/post-editor/post-editor-page.component';
import { PostSearchComponent } from './post-search/post-search.component';
import { TagSelectorComponent } from './post-editor/tag-selector/tag-selector.component';
import { TableNumbersInputComponent } from './post-editor/table-numbers-input/table-numbers-input.component';
import { VulnerabilityRowsInputComponent } from './post-editor/vulnerability-rows-input/vulnerability-rows-input.component';
import { PostCommentComponent } from './post-viewers/post-comments/post-comment.component';
import { PostCommentsComponent } from './post-viewers/post-comments/post-comments.component';
import { PostActionsComponent } from './post-viewers/post-actions/post-actions.component';
import { PostDetailActionsComponent } from './post-viewers/post-detail-actions/post-detail-actions.component';
import { PostUpdatesComponent } from './post-viewers/post-updates/post-updates.component';
import { PostDetailComponent } from './post-viewers/post-detail/post-detail.component';
import { PostSubtitleComponent } from './post-viewers/post-subtitle/post-subtitle.component';
import { PostMapViewComponent } from './post-viewers/post-map-view/post-map-view.component'
import { PostComponent } from './post-viewers/post/post.component';
import { PostGraphComponent } from './post-graph/component/post-graph.component';
import { PostCardSliderComponent } from './post-viewers/post-card-slider/post-card-slider.component';
import { FiltersComponent } from './filters/filters.component';
import { ToastModule } from '../toast/toast.module';
import { ArrayTostringJoinPipe } from './pipes/array-to-string-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { ImportComponent } from '../import/components/import.component';
import { FormsComponent } from './forms/forms.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { UserSignupComponent } from './user-signup/user-signup.component';
import { UserPasswordComponent } from '../user-management/components/user-password/user-password.component';
import { PostHeaderNav } from './header-nav/post-header-nav.component';
import { SliderSelectComponent } from './slider-select/slider-select.component'
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { MapLegendComponent } from './legends/map-legend.component';
import { MapLegendTypeSelectorComponent } from './legends/legend-type-selector/legend-type-selector.component'
import { MapLegendBodyComponent } from './legends/legend-body/legend-body.component'
import { PostPublicCommentComponent } from './post-viewers/post-public-comment/post-public-comment.component'
import { PostCommentListComponent } from './post-viewers/post-comment-list/post-comment-list.component'
import { CaptchaComponent } from '../captcha/components/captcha.component';
import { DashboardComponent } from '../dashboard/components/dashboard.component';
import { ChartComponent } from '../dashboard/Charts/chart.component';
import { PostFiltersComponent } from '../post-filters/components/post-filters.component';
import { MfaModalComponent } from './mfa/mfa-modal.component';
import { PasswordExpiredModalComponent } from './password-expired/password-expired-modal.component';
import { MessageModalComponent } from './message/message-modal.component';
import { TermsConditionsModalComponent } from './terms-conditions/terms-conditions-modal.component';
import { SessionExpiredModalComponent } from './session-expired/session-expired-modal.component';
import { SessionWarningModalComponent } from './session-warning/session-warning-modal.component';
import { ExportColumnsModalComponent } from './export-columns-modal/export-columns-modal.component';

const MODULES = [UIModule];

@NgModule({
    imports: [...MODULES, NgbModule, FontAwesomeModule, MapModule, SearchableSelectModule, ToastModule,
        NgxPaginationModule, NgHttpLoaderModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        PostSubtitleComponent,
        PostComponent,
        PostDetailComponent,
        PostCommentComponent,
        MapLegendComponent,
        PostCommentsComponent,
        PostCardSliderComponent,
        SliderSelectComponent,
        PostHeaderNav,
        PostActionsComponent,
        PostDetailActionsComponent,
        PostUpdatesComponent,
        PostMapViewComponent,
        TagSelectorComponent,
        TableNumbersInputComponent,
        VulnerabilityRowsInputComponent,
        FormAttributeComponent,
        PostEditorPageComponent,
        PostSearchComponent,
        MultiSelectDropdownComponent,
        FiltersComponent,
        PostGraphComponent,
        ArrayTostringJoinPipe,
        ImportComponent,
        FormsComponent,
        UserSignupComponent,
        UserPasswordComponent,
        MapLegendBodyComponent,
        MapLegendTypeSelectorComponent,
        PostPublicCommentComponent,
        PostCommentListComponent,
        CaptchaComponent,
        DashboardComponent,
        ChartComponent,
        PostFiltersComponent,
        MfaModalComponent,
        PasswordExpiredModalComponent,
        MessageModalComponent,
        TermsConditionsModalComponent,
        SessionExpiredModalComponent,
        SessionWarningModalComponent,
        ExportColumnsModalComponent
    ],
    exports: [
        ...MODULES,
        SearchableSelectModule,
        PostSubtitleComponent,
        PostComponent,
        PostDetailComponent,
        PostCommentComponent,
        MapLegendComponent,
        PostCardSliderComponent,
        PostCommentsComponent,
        PostHeaderNav,
        PostActionsComponent,
        PostDetailActionsComponent,
        SliderSelectComponent,
        PostUpdatesComponent,
        PostMapViewComponent,
        TagSelectorComponent,
        FormAttributeComponent,
        PostEditorPageComponent,
        MultiSelectDropdownComponent,
        PostSearchComponent,
        FiltersComponent,
        PostGraphComponent,
        ImportComponent,
        FormsComponent,
        ArrayTostringJoinPipe,
        NgxPaginationModule,
        NgHttpLoaderModule,
        UserSignupComponent,
        UserPasswordComponent,
        MapLegendBodyComponent,
        MapLegendTypeSelectorComponent,
        PostPublicCommentComponent,
        PostCommentListComponent,
        CaptchaComponent,
        DashboardComponent,
        ChartComponent,
        PostFiltersComponent,
        MfaModalComponent,
        PasswordExpiredModalComponent,
        MessageModalComponent,
        TermsConditionsModalComponent,
        SessionExpiredModalComponent,
        SessionWarningModalComponent,
        ExportColumnsModalComponent
    ]
})
export class SharedModule { }
